<template>
  <div>
    <div class="text-right">
      <button
        @click="$parent.onDownloadExcel('user_stat_excel')"
        class="btn btn-sm btn-outline-success"
      >Excel татах</button>
    </div>
    <table class="table table-top-campaign">
      <tbody>
        <tr>
          <th>Улс</th>
        </tr>
        <tr v-for="(country, i) in userStat.country" :key="i">
          <td>{{ country.property }}</td>
          <td>{{ country.count }}</td>
          <td class="progress-container">
            <div class="progress">
              <div
                class="progress-bar bg-info"
                role="progressbar"
                :style="{'width': calcPercentage(country.count, countryMax) + '%'}"
                aria-valuemax="100"
              ></div>
            </div>
          </td>
        </tr>
        <tr>
          <th>Хүйс</th>
        </tr>
        <tr v-for="(sex, i) in userStat.sex" :key="`a${i}`">
          <td>{{ sex.property }}</td>
          <td>{{ sex.count }}</td>
          <td class="progress-container">
            <div class="progress">
              <div
                class="progress-bar bg-info"
                role="progressbar"
                :style="{'width': calcPercentage(sex.count, sexMax) + '%'}"
                aria-valuemax="100"
              ></div>
            </div>
          </td>
        </tr>
        <tr>
          <th>Нас</th>
        </tr>
        <tr v-for="(age, i) in userStat.age" :key="`b${i}`">
          <td>{{ age.property }}</td>
          <td>{{ age.count }}</td>
          <td class="progress-container">
            <div class="progress">
              <div
                class="progress-bar bg-info"
                role="progressbar"
                :style="{'width': calcPercentage(age.count, ageMax) + '%'}"
                aria-valuemax="100"
              ></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "UserStatistic",

  props: ["userStat"],

  created() {
    this.countryMax = Math.max(...this.userStat.country.map(x => x.count));
    this.sexMax = Math.max(...this.userStat.sex.map(x => x.count));
    this.ageMax = Math.max(...this.userStat.age.map(x => x.count));
  },

  data() {
    return {
      countryMax: 0,
      sexMax: 0,
      ageMax: 0
    };
  },

  methods: {
    calcPercentage(count, max) {
      return (count / max) * 100;
    }
  }
};
</script>